<template>
	<footer id="footer">
		<!-- faq -->
		<div class="footer-qna">

			<div class="container">
				<strong>궁금한 내용이 있으신가요?</strong>
				<form @submit.prevent="setBoard">
					<div class="slt-box" v-if="boardInfoVO.isCategory">
						<label for="qna-type">문의 유형</label>
						<select id="qna-type" v-model="boardVO.cateCode">
							<option value="">유형을 선택해 주세요.</option>
							<option v-for="(item, index) in boardInfoVO.cateList" :value="item.code">{{ item.codeName }}</option>
<!--							<option>기술지원</option>
							<option>견적/구매</option>
							<option>교육</option>
							<option>SW 개발</option>
							<option>기타</option>-->
						</select>
					</div>
					<div class="inp-box">
						<label for="qna-title">문의 제목</label>
						<input id="qna-title" type="text" v-model="boardVO.title" placeholder="제목을 입력해 주세요." required>
					</div>
					<div class="txt-box">
						<label for="qna-cont">문의 내용</label>
						<textarea id="qna-cont" rows="8" v-model="boardVO.contentText" placeholder="내용을 입력해 주세요." required></textarea>
					</div>
					<div class="txt-box" v-if="!isLogin()">
						<label for="qna-receiver">메일</label>
						<input type="email" id="qna-receiver" v-model="boardVO.receiver" placeholder="답변 받을 메일을 입력해주세요." required>
					</div>
					<div class="btn-wrap">
						<button type="submit" class="btn-submit">문의 등록하기</button>
					</div>
				</form>
			</div>

		</div>
		<!-- footer menu -->
		<div class="footer-util">
			<div class="container">
				<ul class="footer-menu">
					<li><a href="/app/statics/introduce">상상플렉스 소개</a></li>
					<li><a href="/app/statics/termsofservice">서비스 약관</a></li>
					<li><a href="/app/statics/privacypolicy">개인정보처리방침</a></li>
					<!-- 흑백 icon 파일명 : eatc_black.png -->
					<li><img src="/ssflex/assets/img/common/eatc_white.png" height="24px"></li>
				</ul>
				<div class="partner-menu">
<!--					<div class="vendor-menu dropup">-->
<!--						<button class="btn-drop" type="button" data-toggle="dropdown">Vendor</button>-->
<!--						<div class="list-drop dropdown-menu">-->
<!--							<a class="dropdown-item" href="#">Autodesk</a>-->
<!--							<a class="dropdown-item" href="#">Microsoft</a>-->
<!--							<a class="dropdown-item" href="#">Adobe</a>-->
<!--							<a class="dropdown-item" href="#">Lumion</a>-->
<!--							<a class="dropdown-item" href="#">Unity</a>-->
<!--						</div>-->
<!--					</div>-->
					<div class="family-menu dropup">
						<button class="btn-drop" type="button" data-toggle="dropdown">패밀리 사이트</button>
						<div class="list-drop dropdown-menu">
							<a class="dropdown-item" href="http://www.imbu.co.kr" target="_blank">상상진화</a>
							<a class="dropdown-item" href="http://bimcenter.co.kr/" target="_blank">BIM센터</a>
							<a class="dropdown-item" href="http://www.inno-lab.co.kr/Home/kr/" target="_blank">코스펙이노랩</a>
							<!--							<a class="dropdown-item" href="#">빔센터</a>-->
<!--							<a class="dropdown-item" href="#">코스펙 이노랩</a>-->
<!--							<a class="dropdown-item" href="#">석영시스템즈</a>-->
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- copyright -->
		<div class="footer-copy">
			<div class="container">
				<ul class="link-sns">
					<li><a href="javascript:;" @click="snsOpen('https://www.youtube.com/channel/UCWUeeryencv7vO8QdtdL69g')" class="ico-youtube"><span class="blind">유튜브 바로가기</span></a></li>
					<li><a href="javascript:;" @click="snsOpen('http://pf.kakao.com/_GjtFK')" class="ico-kakaostory"><span class="blind">카카오 스토리 바로가기</span></a></li>
					<li><a href="javascript:;" @click="snsOpen('https://band.us/band/83517670')" class="ico-naverband"><span class="blind">네이버 밴드 바로가기</span></a></li>
				</ul>
				<address v-if="!$options.filters.isEmpty( coInfoVO.coCode )">
					<span>{{ coInfoVO.coName }} 대표이사 {{ coInfoVO.ceoName }}</span><br>
					<span>사업자등록번호 : {{ coInfoVO.bizNumber }}</span>
					<span v-if="!$options.filters.isEmpty(coInfoVO.onlineSaleReportNo)">통신판매업신고 : {{ coInfoVO.onlineSaleReportNo }}</span>
					<span>주소 : {{ coInfoVO.address1 }} {{ coInfoVO.address2 }}</span>
					<span v-if="!$options.filters.isEmpty(coInfoVO.csTel)">대표전화 : {{ coInfoVO.csTel }}</span>
					<span v-if="!$options.filters.isEmpty(coInfoVO.csFax)">FAX: {{ coInfoVO.csFax }}</span>
					<span v-if="!$options.filters.isEmpty(coInfoVO.csEmail)">E-mail: {{ coInfoVO.csEmail }}</span>
					<span>개인정보보호 책임자 : {{ coInfoVO.privacyOfficer }}</span>

<!--				<span>(주)상상진화 대표이사 이병철</span><br>
					<span>사업자등록번호 : 264-81-02576</span>
					<span>통신판매업신고 : 제2021-서울서초-01234호</span>
					<span>주소 : 서울특별시 서초구 서초중앙로2길 38 청산빌딩 3층</span>
					<span>대표전화 : (02) 3474-2270</span>
					<span>FAX: (02) 3474-2265</span>
					<span>E-mail: info@imbu.co.kr</span>
					<span>개인정보보호 책임자 : 홍길동(it@sangsangflex.com)</span>-->
				</address>
				<p>© sangsangflex. All Rights Reserved</p>
			</div>
		</div>
	</footer>
</template>

<script>
import $ from "jquery";
import Swiper from "../../../public/ssflex/assets/js/swiper.min";

export default {
	name: "partialFooter",
	data() {


		return {
			coInfoVO: new this.CoInfo(),

			boardKey: "site_qna",
			boardInfoVO: new this.BoardInfoVO(),
			boardVO: new this.BoardVO(this.getSessionProc()),
		}
	},
	created() {

		this.getCompanyInfo();
		this.getBoardInfo();
	},
	mounted() {

	},
	updated() {

	},
	methods: {
		snsOpen(url) {
			const temp = {
				isCloseBTN : "Y",
				url: url,
			}
			this.appOpen( temp );
		},

		getCompanyInfo () {

			this.axiosCaller.get( this, this.APIs.CO_INFO + "/" + this.webUtils.getSubdomain(), {}, (res) => {
				const result = res.data
				if ( result.status === "ok" ) {
					this.coInfoVO = result.coInfoVO
				} else {
					console.log( result.msg )
				}
			})
		},


		getBoardInfo () {

			this.axiosCaller.get( this, this.APIs.BOARDS + "/getBoardInfo", {
				boardKey: this.boardKey
			}, (res) => {
				var result = res.data
				if ( result.status === "ok" ) {
					this.boardInfoVO = result.boardInfoVO
				}
			});
		},


		setBoard(e) {

			e.preventDefault()

			this.boardVO.boardKey = this.boardKey
			this.boardVO.contentHtml = this.boardVO.contentText
			this.boardVO.writerKey = this.getLoginId()
			if ( this.isLogin() ) {
				this.boardVO.writer = this.getSessionProc().userName
			} else {
				this.boardVO.writer = this.getLoginId()
			}

			// 문의 메일 발송
			this.boardVO.isSendMail = true

			this.$eventBus.$emit("startProgress")
			this.axiosCaller.post( this, this.APIs.BOARDS + "/setBoardOne", this.boardVO, (res) => {
				this.$eventBus.$emit("doneProgress")
				const result = res.data
				console.log( result )
				if ( result.status === "ok" ) {
					this.swalUtils.gritter("Success", "문의 내용이 등록되었습니다.", "success", 800)
					this.boardVO = new this.BoardVO();
				}
			})

		},


	},
}
</script>

<style scoped>

</style>
